import { useMemberApi } from "../api/MemberApiClient";
import { MemberFrontendService } from "../services/MemberFrontendService";

export const useMemberService = (): MemberFrontendService =>
  new MemberFrontendService(useMemberApi());
